import { giphyBlack } from '@giphy/colors'
import { useMemo } from 'react'
import SegmentedControl from 'ui/src/components/controls/segmented-control'
import { ugeStrokeSizes } from '../../../types'
import { labelFromStrokeSize, widthFromStrokeSize } from '../../../utilities/stroke-size'
import { Subheading } from '../../style'
import Color from './color'
import { StrokeOptions } from './style'

const STROKE_SIZES = ugeStrokeSizes.map(labelFromStrokeSize)

type Props = {
    buttonColor?: string
    color?: string
    strokeSize?: number
    onColorChange?: (color: string) => void
    onSizeChange?: (size?: number) => void
}

const UGECaptionsEditorStroke = ({
    buttonColor = giphyBlack,
    color,
    strokeSize = 0,
    onColorChange,
    onSizeChange,
}: Props) => {
    const defaultStrokeSizeIndex: number = useMemo(() => {
        const index = ugeStrokeSizes.findIndex((size) => {
            if (widthFromStrokeSize(size) === strokeSize) {
                return true
            }
            return false
        })

        return Math.max(index, 0)
    }, [strokeSize])

    function onStrokeSizeChange(index: number) {
        const width = widthFromStrokeSize(ugeStrokeSizes[index])

        onSizeChange?.(width)
    }

    return (
        <Color
            buttonColor={buttonColor}
            color={color}
            icon={!color || !strokeSize ? 'stroke-off' : 'stroke'}
            label="Outline Color"
            onChange={onColorChange}
        >
            <StrokeOptions>
                <Subheading>Thickness</Subheading>
                <SegmentedControl
                    defaultIndex={defaultStrokeSizeIndex}
                    options={STROKE_SIZES}
                    onChange={onStrokeSizeChange}
                />
            </StrokeOptions>
        </Color>
    )
}

export default UGECaptionsEditorStroke
